import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-3 mb-4" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { class: "bg-white w-full text-gray-600 divide-y" }
const _hoisted_4 = { class: "text-black" }
const _hoisted_5 = { class: "p-6 text-left font-normal" }
const _hoisted_6 = { class: "p-6 text-left font-normal" }
const _hoisted_7 = { class: "p-6 text-left font-normal" }
const _hoisted_8 = { class: "p-6 text-green-600" }
const _hoisted_9 = { class: "p-6" }
const _hoisted_10 = { class: "p-6" }

import { ref, PropType, computed } from "vue";
import Button from "@/components/common/Button.vue";
import DocumentAccessCreateModal from "@/components/documents/DocumentAccessCreateModal.vue";
import { TrashIcon } from "@heroicons/vue/outline";
import { DocumentDataService } from "@/services";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { AuthGetters } from "@/store/modules/auth";
import {
  DocumentAccess,
  DocumentAccessTypes,
} from "@/types/documents/document/DocumentAccess";
import { getDocumentAccessLabel } from "@/utils/labels";
import { t } from "@/i18n";


export default /*#__PURE__*/_defineComponent({
  props: {
  documentId: {
    type: String,
    required: true,
  },
  documentStatus: {
    type: String,
    required: true,
  },
  documentAccesses: {
    type: Array as PropType<DocumentAccess[]>,
    default: () => [],
    required: true,
  },
},
  setup(__props) {

const props = __props


const router = useRouter();
const store = useStore();

const documentAccessCreateModalIsShow = ref(false);
const modalMode = ref<"VIEW" | "CO_EDITOR">("VIEW");
const currentUser = computed(() => store.getters[AuthGetters.GET_USER_IDENTITY]);
const excludedUserIds = computed(() =>
  props.documentAccesses
    .filter(
      (documentAccess) =>
        documentAccess.type === modalMode.value ||
        documentAccess.type === DocumentAccessTypes.CREATOR
    )
    .map((documentAccess) => documentAccess.userInfo?.id)
    .filter((userId): userId is string => userId != null)
);
const canGrantCoEditor = computed(() =>
  Array.isArray(currentUser.value?.permissions) &&
  currentUser.value.permissions.includes("DOCUMENT_ACCESS_CO_EDITOR_GRANT")
);

const openModal = (mode: "VIEW" | "CO_EDITOR") => {
  modalMode.value = mode;
  documentAccessCreateModalIsShow.value = true;
};

const deleteAccessHandler = async (userId: string) => {
  try {
    await DocumentDataService.deleteCoEditor(props.documentId, userId);
    router.go(0);
  } catch (e) {
    console.error(e);
  }
};
const documentAccessCreateModalSubmitHandler = () => {
  router.go(0);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (openModal('VIEW')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("documentAccess.grantAccess")), 1)
        ]),
        _: 1
      }),
      (_unref(canGrantCoEditor))
        ? (_openBlock(), _createBlock(Button, {
            key: 0,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (openModal('CO_EDITOR')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("documentAccess.grantCoEditor")), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "table-scroll",
      style: {"--table-min-width":"560px"},
      tabindex: "0",
      role: "region",
      "aria-label": _ctx.$t('common.scrollableTable')
    }, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("tr", _hoisted_4, [
          _createElementVNode("th", _hoisted_5, _toDisplayString(_unref(t)("documentAccess.user")), 1),
          _createElementVNode("th", _hoisted_6, _toDisplayString(_unref(t)("documentAccess.accessType")), 1),
          _createElementVNode("th", _hoisted_7, _toDisplayString(_unref(t)("documentAccess.action")), 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.documentAccesses, (documentAccess, index) => {
          return (_openBlock(), _createElementBlock("tr", { key: index }, [
            _createElementVNode("td", _hoisted_8, _toDisplayString(documentAccess.userInfo.fullName), 1),
            _createElementVNode("td", _hoisted_9, _toDisplayString(_unref(getDocumentAccessLabel)(documentAccess.type)), 1),
            _createElementVNode("td", _hoisted_10, [
              (documentAccess.type === _unref(DocumentAccessTypes).CO_EDITOR)
                ? (_openBlock(), _createBlock(Button, {
                    key: 0,
                    onClick: ($event: any) => (deleteAccessHandler(documentAccess.userInfo.id))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TrashIcon), { style: {"width":"16px"} })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ])
    ], 8, _hoisted_2),
    _createVNode(DocumentAccessCreateModal, {
      documentId: __props.documentId,
      show: documentAccessCreateModalIsShow.value,
      mode: modalMode.value,
      "excluded-user-ids": _unref(excludedUserIds),
      onHide: _cache[2] || (_cache[2] = ($event: any) => (documentAccessCreateModalIsShow.value = false)),
      onSubmit: documentAccessCreateModalSubmitHandler
    }, null, 8, ["documentId", "show", "mode", "excluded-user-ids"])
  ], 64))
}
}

})